import { EnvironmentBase } from './environment.base';
import { LogLevel } from '@core/logging';

export const environment: EnvironmentBase = {
  production: false,
  logLevel: LogLevel.All,
  hmr: false,
  aadAuthorityDomain: 'pasmb2cdev.b2clogin.com',
  aadClientId: '6c9c78e5-7c5c-42dc-b956-2ac2b6b276d0',
  aadEditprofileUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
  aadScope: 'https://pasmb2cdev.onmicrosoft.com/pasm-edb-api-test/API.Access',
  aadSignupSigninUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_KPT',
  aadGroupPrefix: 'EDB-TEST',
  baseUrl: 'https://pasm-edb-api-test.pasmapps.de',
  reports: {
    actualTarget:
      'https://app.powerbi.com/reportEmbed?reportId=f2e38d5b-7566-467a-8f8c-fa0d8a510e66&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    bhkw: 'https://app.powerbi.com/reportEmbed?reportId=d28371d4-8152-4fc1-b2b2-7a4a963a5424&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    energyDevelopment:
      'https://app.powerbi.com/reportEmbed?reportId=deff4a50-5815-4363-9ec7-f2afb264938f&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    generalReport:
      'https://app.powerbi.com/rdlEmbed?reportId=6b4e65a6-7aea-4347-903f-1ed566772dc2&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4&experience=power-bi',
    importStatus:
      'https://app.powerbi.com/reportEmbed?reportId=f597e854-831e-4bbd-86ea-b5b5ad6d056c&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    loadProfile:
      'https://app.powerbi.com/reportEmbed?reportId=c484bb0f-0ad9-47e0-ab35-5a5145f87adf&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    materials:
      'https://app.powerbi.com/reportEmbed?reportId=1643a03b-afdd-433a-ba12-e30003b31da9&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    meterReading:
      'https://app.powerbi.com/reportEmbed?reportId=a4c74f53-5157-4a10-bb5f-792aae5fca4b&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    objectConsumption:
      'https://app.powerbi.com/reportEmbed?reportId=4cef4f6e-eda2-4618-b90f-568066756fe9&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    overviewTotal:
      'https://app.powerbi.com/reportEmbed?reportId=3007ab4a-0e57-4524-8b4f-05ca22cccf78&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    overviewSmp:
      'https://app.powerbi.com/reportEmbed?reportId=f78b3256-8c08-4d67-b3c0-cb8d8b180a71&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    profileAnalysis:
      'https://app.powerbi.com/reportEmbed?reportId=db50ea33-e9cc-4069-a113-f0a6c4541cad&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    profilePv:
      'https://app.powerbi.com/reportEmbed?reportId=17474b9f-ad93-43a3-b7a6-c1890f01291e&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    pue: 'https://app.powerbi.com/reportEmbed?reportId=89a5b4ed-d522-4d97-b604-7d5f6a4e129c&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    smops:
      'https://app.powerbi.com/reportEmbed?reportId=257d09d0-3309-40df-892a-cd53bdba340c&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    totalLoad:
      'https://app.powerbi.com/reportEmbed?reportId=773e333f-fea9-4c29-8c95-2d2ae383b101&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
    zeroHourLoad:
      'https://app.powerbi.com/reportEmbed?reportId=3d1f3783-f8cd-492a-b78a-4aa9919014ee&autoAuth=true&ctid=49739356-361e-40c0-a394-e228268328a4',
  },
  spaUrl: 'https://spa-test.power-air-solutions.de',
};
